module.exports = __webpack_public_path__ + "img/sparkarena-thumb.2204845e.jpg";